import { TComboboxItemWithData } from '@udecode/plate';
import { EmojiSearchData } from './types';

export const emojisToComboboxItems = (
  emojis: EmojiSearchData[]
): Array<TComboboxItemWithData<EmojiSearchData>> => {
  return emojis.map((emoji) => ({
    key: emoji.id,
    text: emoji.id,
    data: emoji,
  }));
};
